export default {
  token_expired_title: 'This invite link is no longer active.',
  token_expired_message1: 'Please reach out to',
  token_expired_message2: 'to see if there is a new link available.'
};
